import { render, staticRenderFns } from "./ElpLocallyWidget.vue?vue&type=template&id=6bd01a32&"
import script from "./ElpLocallyWidget.vue?vue&type=script&lang=js&"
export * from "./ElpLocallyWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports